<template lang="pug">
.other-office-message-reply
  .register-body
    FormTextarea.mr-2(v-model="_text" key-name="" :name="`${name}-reply-text`" placeholder="返信"
      :validation-rules="{ required: true, max: 1000 }" validationKeyName="返信"
      :maxlength="1000" :styles="{ minWidth: '220px', width: '100%', height: '41px' }" required)
  .d-flex.mb-2
    DraggableFiles.draggable-files(v-model="_files" @delete="onFileDelete" :item-width="'90%'")
  .d-flex.justify-content-end
    MultiFileSelecter.mr-2(:name="`${name}-reply-temp-files`" :mimetypes="_mimeTypes" :limit="_registerFilesLimit" :width="'100%'" :height="'32px'"
      :showPreview="false" @input="inputFiles")
    .error-messages.text-break(v-for="error in errors.collect(`${name}-reply-temp-files`)")
      label.error-message {{ error }}
      br
    button.btn.reply-btn(@click="onReply") 返信
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import OtherOfficeMessageFileService from "@/commons/services/OtherOfficeMessageFile";

import { OtherOfficeMessageListTabMessageReplyInput } from "@/pc/containers/sendOtherOfficeMessages/OtherOfficeMessageListTab.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";
import DraggableFiles from "@/pc/components/DraggableFiles.vue";

/**
 * ### メッセージの返信入力コンポーネント
 */
@Component({
  components: {
    FormTextarea,
    MultiFileSelecter,
    DraggableFiles
  },
  $_veeValidate: { validator: "new" }
})
export default class OtherOfficeMessageReplyInput extends Vue {
  /** 返信情報 */
  @Prop()
  value!: OtherOfficeMessageListTabMessageReplyInput;
  /** nameで使用するkey */
  @Prop()
  name!: number;
  /** 添付ファイル最大数 */
  @Prop()
  fileUploadLimit!: number;
  /** 添付許可Content-Typeリスト */
  @Prop()
  mimeTypes!: string[];

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  get _text(): string {
    return this.value.text;
  }

  set _text(newValue: string) {
    this.value.text = newValue;
    return;
  }

  get _files(): Array<File> {
    return this.value.files;
  }

  get _mimeTypes(): string[] {
    if (this.mimeTypes) {
      return this.mimeTypes;
    } else {
      return [];
    }
  }

  /** ### 登録可能なファイル数を返す */
  get _registerFilesLimit(): number {
    if (this.value && this.fileUploadLimit) {
      const limit: number = this.fileUploadLimit - this.value.files.length;
      return limit;
    } else {
      return 0;
    }
  }

  public resetFiles(): void {
    this.value.files = [];
    return;
  }

  public async inputFiles(files: Array<File>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const service: OtherOfficeMessageFileService = new OtherOfficeMessageFileService(this.$validator, `${this.name}-reply-temp-files`);
    const addFiles: Array<File> = await service.createAddFile(files, this._registerFilesLimit, this.value.files.length);
    if (0 < addFiles.length) {
      this.value.files = this.value.files.concat(addFiles);

      for (let i = 0; i < this.value.files.length; i++) {
        this.value.files[i].key = i.toString();
      }
    }

    this.isBusy = false;
    return;
  }

  /**
   * ### ファイル削除イベント
   */
  public onFileDelete(index: number): void {
    this.value.files.splice(index, 1);
    return;
  }

  public async onReply(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.$emit("onReply", { value: this.value, datetime: this.name });
    }
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.other-office-message-reply {
  ::v-deep {
    .register-group {
      margin: 0 !important;
    }
    .register-row {
      margin-bottom: 0.5rem;
    }
  }
  .reply-btn {
    width: 60px;
    height: 32px !important;
    font-size: 14px !important;
  }
}
</style>
